import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import setting from "../setting.json";

const ComplainList = () => {

    const [list, setList] = useState();

    const getAllComplaints = async () => {
        await fetch(setting.api + "api/getAllComplaints", {
            method: "GET",
            mode: "cors",

        })
            .then(response => response.json())
            .then(c => {
                setList(c.data);

            });
    }

    useEffect(() => {
        getAllComplaints();
    })

    return (
        <>
            <Header />
            <Sidebar />
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Complaints</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item active">Data</li>
                        </ol>
                    </nav>
                </div>

                <Table striped bordered hover variant="">
                    <thead>
                        <tr>
                            <th>Sr.No.</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Message</th>

                        </tr>
                    </thead>
                    <tbody>
                        {list && list.map((c, i) =>
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{c.name}</td>
                                <td>{c.email}</td>
                                <td>{c.message}</td>

                            </tr>
                        )}


                    </tbody>
                </Table>
            </main>
            <Footer />
        </>
    )
}
export default ComplainList;